<template>
  <div class="dgp-container">
    <iframe
      id="frame_vprivacy"
      :key="uuidv4()"
      ref="iframe"
      class="frame_vprivacy"
      :src="urlSrc"
      frameborder="0"
      title=""
    ></iframe>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { h } from 'vue';
import { useRoute } from 'vue-router';
import { v4 as uuidv4 } from 'uuid';

import { getSession, removeToken } from '@/utils/storage';
import { setToken } from '@/utils/system';
import { loginOut } from '@/api/login';
import { getNewDgpNotice } from '@/api/system';

// const route: any = useRoute();
// const path = route.query.path;
// const pathId = route.query.pathId;

const xToken = getSession('Admin-Token');
const VITE_GLOB_DGP: string = import.meta.env.VITE_GLOB_DGP;
const urlSrc = VITE_GLOB_DGP.replace('code=edmtoken', `code=${xToken}` + `&t=${new Date().getTime()}`);
const iframe = ref(null);
onMounted(() => {
  window.addEventListener('message', handleMessage);
  fetchNotice();
});

onUnmounted(() => {
  window.removeEventListener('message', handleMessage);
});

const fetchNotice = async () => {
  const res = await getNewDgpNotice();
  const { showFlag, text } = res;
  if (showFlag) {
    window.$dialog.warning({
      title: 'Notice',
      content: () =>
        h('div', {
          innerHTML: text,
        }),
      negativeText: 'Close',
      maskClosable: false,
      style: {
        width: '500px',
      },
    });
  }
};

const handleMessage = (event: any) => {
  const { data } = event;
  const jsonData = JSON.parse(data);
  if (jsonData.loginout === 'true') {
    loginOut().then(() => {
      const didlogoutUrl = import.meta.env.VITE_GLOB_DID_LOGOUT_URL;
      removeToken('userInfo');
      removeToken('Admin-Token');
      window.location.href = didlogoutUrl;
    });
  } else if (jsonData.setToken) {
    setToken(jsonData.setToken);
  }
};
</script>

<style lang="scss" scoped>
.dgp-container {
  height: calc(100vh - 56px);
  font-size: 0;
}
.frame_vprivacy {
  width: 100%;
  height: calc(100%);
  // height: 100%;
}
</style>
